import { observer } from 'mobx-react';
import { Auth } from 'models';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorView, LoadingView } from 'views/Interstitial';
import { APIState } from '../../../models/APIState';
import DemoMFEView from './DemoMFEView';

const DemoMFEController = ({ viewModel }: { viewModel: Auth }) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'Connect Demo MFEs';
  }, []);

  switch (viewModel.status) {
    case APIState.LOADING:
      return <LoadingView />;
    case APIState.FAIL:
      return (
        <ErrorView
          errorMessage={t('resource-mapper.no_crop_org')}
          errorDetails={t('resource-mapper.try_diff_org')}
        />
      );
    case APIState.SUCCESS:
    case APIState.EMPTY:
      return <DemoMFEView viewModel={viewModel} />;
    default:
      return null;
  }
};

export default observer(DemoMFEController);
